<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    :scrollable="false"
    sizeClass="modal-xl"
    icon="fa-sparkles"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3" v-if="!loading">
      <FormRow label="Name">
        <FormInputText v-model="agentData.name" field="name" placeholder="Name" />
      </FormRow>
      <FormRow label="Title">
        <FormInputText v-model="agentData.title" field="title" placeholder="Title" />
      </FormRow>
      <FormRow label="Avatar">
        <FormSelect v-model="agentData.avatarType" :options="AIAvatarTypeLookup" />        
      </FormRow>            
      <FormRow>
        <FormStaticLabel>
          <Avatar :name="agentData.name" :image="agentProfilePicURL" :editable="false" :size="80" />
        </FormStaticLabel>
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'
import Avatar from '@/components/avatar.vue'

import { AIAvatarTypeLookup } from '@/store/types'

export default {
  name: 'AIAgentDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    Avatar
  },
  props: {
    id: Number,
  },
  data() {
    return {
      dialogForm: {},
      agentData: {        
      },
      submitting: false,
      loading: false,
      loadingError: '',
    }
  },
  created() {
    this.AIAvatarTypeLookup = AIAvatarTypeLookup
  },
  mounted() {
    if(this.id) {
      this.loading = true
      this.loadingError = ''

      this.requestData()
      .then(() => {
      })
      .catch(err => {
        this.loadingError = 'Error loading data. Check your internet connection and try again'
      })
      .finally(() => {
        this.loading = false
      })
    }
  },
  computed: {
    title() {
      return 'Edit Agent'
    },
    submitTitle() {
      return 'Update'
    },
    agentProfilePicURL() {
      return `/ai/images/${this.agentData.avatarType}.png`
    }
  },
  methods: {
    show() {
      // Reset form
      this.agentData = {
        
      }
      this.dialogForm = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.agentData)
      
      this.$apiService.aiService.updateAgent(this.id, updateData)
      .then(response => {
        this.submitting = false
        this.modalClosed(response.data.id)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.dialogForm = this.processFormResponse(err)
      })
    },
    requestData() {
      return new Promise((resolve, reject) => {

        this.$apiService.aiService.getAgent(this.id)
        .then(response => {
          this.agentData = response.data

          return resolve()
        })
        .catch(err => {
          return reject(err)
        })
      })
    }
  }
}
</script>